import { forwardRef } from 'react';

import { useSelector } from '@hh.ru/front-static-app';

// eslint-disable-next-line react/display-name
const Form = forwardRef<HTMLFormElement, React.ComponentPropsWithoutRef<'form'>>(
    ({ children, method = 'POST', ...props }, ref) => {
        const xsrfToken = useSelector(({ request }) => request.xsrfToken);
        return (
            // eslint-disable-next-line react/forbid-elements
            <form {...props} ref={ref} method={method}>
                {method.toUpperCase() === 'POST' && <input type="hidden" name="_xsrf" value={xsrfToken} />}
                {children}
            </form>
        );
    }
);

export default Form;
